import { UploadButton } from '@bytescale/upload-widget-react';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { ProfilePicture } from 'components/common/ProfilePicture';
import React, { useEffect, useState } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form';
import PhoneInput from 'components/common/PhoneInput';
import { useDispatch, useSelector } from 'react-redux';
import { cdn } from 'constants/common';
import { setError } from 'slices/userSlice';
import toast from 'react-hot-toast';
import FullPageLoader from 'components/common/FullPageLoader';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { fetchStates } from 'slices/stateSlice';
import { Select } from 'components/common/Select';
import { stateSelector } from 'slices/stateSlice';
import { fetchLanguages } from 'slices/languageSlice';
import { citySelector } from 'slices/citySlice';
import { fetchVendorProfile } from 'slices/vendor/profileSlice';
import { updateVendorProfile } from 'slices/vendor/profileSlice';
import { vendorProfileSelector } from 'slices/vendor/profileSlice';

const ShowProfile = ({ item, handleEdit }) => {

    const InfoRow = ({ label, value }) => (
        <tr>
            <td className='col-3'><strong>{label}</strong></td>
            <td className='col-9'>{value || 'N/A'}</td>
        </tr>
    );


    return (
        <div className='container_main mt-4 profile-container'>
            <div className="profile-header">
                <div className="profile-image">
                    {/* <ProfilePicture imageUrl="/images/default-person.png" /> */}
                    <ProfilePicture imageUrl={item?.image ? (cdn + item?.image) : '/images/default-person.png'} />
                </div>
                <div className="profile-info">
                    <h1 className='text-capitalize'>{item?.name}</h1>
                    <p>{item?.address}</p>
                    <div className="edit_prof">
                        <button type='button' className='main_button' onClick={handleEdit}>
                            <i className="fa-solid fa-pen-to-square"></i>&nbsp;&nbsp;
                            <span>Edit Profile</span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="profile-section">
                <h2>Personal Information</h2>
                <table>
                    <InfoRow label="Name:" value={item?.name} />
                    <InfoRow label="Email:" value={item?.email} />
                    <InfoRow label="Role:" value={item?.role == 'vendor'? 'Vendor' : "N/A"} />
                </table>
            </div>

        </div>
    );
};


const Profile = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm();
    const { vendorProfile: item, error, loader } = useSelector(vendorProfileSelector);
    const { state: states } = useSelector(stateSelector);
    const { city: cities } = useSelector(citySelector);
    const [activeEdit, setActiveEdit] = useState(false)
    const [localImage, setLocalImage] = React.useState('')
    const [allStates, setAllStates] = useState([]);
    const [filterStates, setfilterStates] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        Promise.allSettled(
            [dispatch(fetchVendorProfile())]
        )
    }, [])
    useEffect(() => {
        setValue('name', item?.name || '');
        setValue('email', item?.email || '')
        dispatch(setError({}));

    }, [item, activeEdit, setValue])

    useEffect(() => {
        if (states?.length > 0) {
            if (item?.state_id)
                setValue("state_id", item?.state_id)
        }
        else setValue("state_id", "")

        if (item?.city_id) {
            setValue("city_id", item?.city_id)
        }
        else {
            setValue("city_id", "")
        }

    }, [item, cities, states]);


    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            dispatch(fetchVendorProfile())
            handleCancelEdit()
        }
        else {
            console.log('onSubmit', error)
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const onSubmit = (data) => {
        dispatch(setError({}))
        data = {
            ...data,
        };

        dispatch(updateVendorProfile(data, submitCallback));
    }

    const options = {
        apiKey: "free",
        maxFileCount: 1
    };

    function handleEdit() {
        dispatch(fetchVendorProfile())
        setActiveEdit(true)
    }

    function handleCancelEdit() {
        dispatch(fetchVendorProfile())
        setActiveEdit(false)
    }

    const handleChangeSwitch = (checked, onChange) => {
        onChange(checked ? 1 : 0); // convert true => 1, false => 0
      };
      

    return (
        <div className="content">
            <div className="row_main_head">
                <h2 className="main_heading">Profile Page</h2>
            </div>
            {activeEdit === false ?
                <ShowProfile item={item} handleEdit={handleEdit} />
                :
                <div className='container_main mt-4'>
                    <form className='profile_form' onSubmit={handleSubmit(onSubmit)}>

                        {/* Main credientials area  */}
                        <div className="row-primary">
                            <h2>Profile Picture</h2>

                            <div className='Upload_wrapper'>
                                {(localImage || item?.image) &&
                                    <div className='image_preview'>
                                        <ProfilePicture imageUrl={item?.image ? (cdn + item?.image) : '/images/default-person.png'} />
                                    </div>
                                }
                                <div className='w-100'>
                                    <Controller name="image" control={control} render={({ field }) =>
                                    (
                                        <UploadButton options={options}
                                            onComplete={files => {
                                                const file = files[0];
                                                setLocalImage(file?.fileUrl);
                                                field.onChange(file?.originalFile?.file);
                                            }}>
                                            {({ onClick }) =>
                                                <button type='button' onClick={onClick}>
                                                    <i className="fa-solid fa-camera"></i>&nbsp;&nbsp;
                                                    <span>Upload New</span>
                                                </button>
                                            }
                                        </UploadButton>
                                    )}
                                    />
                                    {error?.errors?.image?.map((error) => (
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={error} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className='foam_page_row'>

                            <div className="row-primary w-100">
                                <h2>Name *</h2>
                                <Controller
                                    name="name"
                                    rules={{
                                        required: "name is required",
                                    }}
                                    control={control}
                                    render={({ field }) =>
                                        <div className="w-100">
                                            <input className="input-in type_inp" type="text" name='first-name' placeholder='First name' {...field} />
                                            {error?.errors?.first_name?.length > 0 && (
                                                error?.errors?.first_name?.map((error) => <ErrorMessage text={error} />)
                                            )}
                                            {errors?.first_name?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.first_name?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>

                            <div className="row-primary w-100">
                                <h2>Email *</h2>
                                <Controller
                                    name="email"
                                    rules={{
                                        required: "Email is required",
                                    }}
                                    control={control}
                                    render={({ field }) =>
                                        <div className='w-100'>
                                            <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" name='email'
                                                pattern={
                                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                }
                                                placeholder="Email Address"
                                                {...field}
                                            />
                                            {error?.errors?.email?.map((error) => (
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={error} />
                                                </div>
                                            ))}
                                            {errors?.email?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.email?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>


                        </div>

                        <div className="Form-footer">
                            <button type='button' className='Cancle_button' onClick={handleCancelEdit}>Cancel</button>
                            <SubmitButton btnText={"Update Profile"} loader={loader} />
                        </div>
                    </form>
                </div>
            }
            {loader && <FullPageLoader loader={loader} />}
        </div>
    )
}

export default Profile